<!-- https://xd.adobe.com/view/5a99e1ec-5384-4360-a0f7-d32f2e012228-0fca/screen/1ff9bcf9-2ed0-4098-9950-cffa7fd3ce31/specs/ -->
<!-- https://docs.google.com/presentation/d/1d_O6nM_jbVWXj20W_5KjxkR_8fwRXV3JKD3D4bXYOqM/edit#slide=id.g13a94655b6d_0_0 -->
<!-- https://docs.google.com/document/d/1JOy1cSFY-KGBVHjjZMcWkEtaLlliAzMHHh6ceHp8gBo/edit -->
<template>
  <div class="clearfix gibson px0">
    <div class="xs-col-12 sm-col-12 md-col-6 lg-col-7 px0">
      <button v-b-toggle.moreReviews name="moreReviews" class="hide col-12 action-button p2 line-height-1 h5 flex justify-center items-center gibson">
        <span class="semi-bold mr2 mb0">Indhent flere anbefalinger</span>
        <span class="when-closed">
          <span class="relative" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
          </span>
        </span>
        <span class="flex-none when-opened">
          <span class="relative" style="top:3px;">
            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
          </span>
        </span>
      </button>
    </div>
    <div class="col-12 px0">
        <div class="clearfix gibson pb3">
          <div class="col-12 px0 mt3">
            <b-form class="collectReviewForm" @submit.stop.prevent="service_invitation">
              <div class="clearfix mb2">
                <p class="h5 darkblue regular gibson line-height-3 mb1" id="nameInput">
                  Kundens navn
                </p>
                <b-form-input clas="muted-background gibson darkblue p2 border-none not-rounded h5" id="navn" type="text" v-model="form.name" required placeholder=""></b-form-input>
              </div>
              <div class="clearfix mb2" id="emailInput">
                <p class="h5 darkblue regular gibson line-height-3 mb1">
                  Kundens email
                </p>
                <b-form-input clas="muted-background gibson darkblue p2 border-none not-rounded h5" id="email" type="email" v-model="form.email" required placeholder=""></b-form-input>
              </div>
              <div class="clearfix mb2" id="telInput">
                <p class="h5 darkblue regular gibson line-height-3 mb1">
                  Kundens telefon
                </p>
                <b-form-input clas="muted-background gibson darkblue p2 border-none not-rounded h5" id="tel" type="tel" v-model="form.telefon" required placeholder=""></b-form-input>
              </div>
              <div class="clearfix mb1" id="method">
                <p class="h5 darkblue regular gibson line-height-3 mb1">
                  Vælg metode
                </p>
                <b-form-select class="muted-background gibson darkblue border-none not-rounded h5" v-model="form.method" id="method" required>
                  <option value="1">Både SMS og e-mail</option>
                  <option value="2">Kun e-mail</option>
                  <option value="3">Kun SMS</option>
                </b-form-select>
              </div>
              <b-collapse id="extraInvite">
                <div class="clearfix my2 py2 border-top muted-border">
                  <p class="h5 darkblue regular gibson line-height-3 mb1" id="nameInput">
                    Kundens navn
                  </p>
                  <b-form-input clas="muted-background gibson darkblue p2 border-none not-rounded h5" id="navn" type="text" v-model="form.name" required placeholder=""></b-form-input>
                </div>
                <div class="clearfix mb2" id="emailInput">
                  <p class="h5 darkblue regular gibson line-height-3 mb1">
                    Kundens email
                  </p>
                  <b-form-input clas="muted-background gibson darkblue p2 border-none not-rounded h5" id="email" type="email" v-model="form.email" required placeholder=""></b-form-input>
                </div>
                <div class="clearfix mb2" id="telInput">
                  <p class="h5 darkblue regular gibson line-height-3 mb1">
                    Kundens telefon
                  </p>
                  <b-form-input clas="muted-background gibson darkblue p2 border-none not-rounded h5" id="tel" type="tel" v-model="form.telefon" required placeholder=""></b-form-input>
                </div>
                <div class="clearfix mb1" id="method">
                  <p class="h5 darkblue regular gibson line-height-3 mb1">
                    Vælg metode
                  </p>
                  <b-form-select class="muted-background gibson darkblue border-none not-rounded h5" v-model="form.method" id="method" required>
                    <option value="1">Både SMS og e-mail</option>
                    <option value="2">Kun e-mail</option>
                    <option value="3">Kun SMS</option>
                  </b-form-select>
                </div>
              </b-collapse>
              <div class="flex justify-between items-center mt2 mb1">
                <button v-b-toggle.extraInvite class="hide outlined-action-button p2 px3 gibson flex justify-center items-center not-rounded">
                  <span class="h5 semi-bold ml1 mb0">Tilføj flere</span>
                  <span class="mx1"><i class="el-icon-circle-plus-outline"></i></span>
                </button>
                <button type="submit" class="action-button p2 px3 gibson flex justify-center items-center border-none not-rounded">
                  <span class="h5 semi-bold ml1 mb0">Send</span>
                  <span class="mx1"><i class="el-icon-right"></i></span>
                </button>
              </div>
            </b-form>
          </div>
        </div>
        <loading :show="show" :label="label" :overlay="overlay"></loading>
        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'collectreviews',
  components: {
    loading,
    Simplert
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        telefon: '',
        method: '1'
      },
      show: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      overlay: 1
    }
  },
  methods: {
    service_invitation () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      if (localStorage.getItem('haaid') === '0') {
        return
      }
      var dataPartner = {operation: 'invitation', salesPerson: this.salesPerson, levid: this.haaId, email: this.form.email, requesterName: this.form.name, telephone: this.form.telefon, method: this.form.method}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.form.email = ''
              this.form.name = ''
              this.form.telefon = ''
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectReview.vue?08bde436